<template>
  <q-dialog :value="value" @input="$emit('input', $event)">
    <q-card class="team-members__confirm-dialog">
      <q-card-section class="team-members__dialog-header">
        <h5 class="q-mt-none q-mb-xs team-members__dialog-title">Remove team member</h5>
        <q-btn flat round icon="close" size="sm" v-close-popup class="team-members__close-btn" />
      </q-card-section>

      <q-card-section>
        <p>Are you sure you want to remove this team member? This action cannot be undone.</p>
      </q-card-section>

      <q-card-section class="team-members__dialog-footer">
        <q-btn flat no-caps label="Cancel" v-close-popup class="team-members__cancel-btn" />
        <q-btn label="Remove" flat no-caps class="team-members__primary-btn team-members__primary-btn--negative" @click="$emit('confirm')" :loading="isRequesting" />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    value: Boolean,
    isRequesting: Boolean
  }
};
</script>

<style lang="scss" scoped>
@import './team-members-styles.scss';
</style>
